import { APP_SETTINGS } from "../../config";
import axios from "axios";

export function createStickyNote(data) {
  var response = axios.post(
    APP_SETTINGS.API_PATH.STICKY_NOTES.createStickyNote,
    data
  );
  return response;
}

export function editStickyNote(id, data) {
  var response = axios.patch(
    `${APP_SETTINGS.API_PATH.STICKY_NOTES.editStickyNote}?id=${id}`,
    data
  );
  return response;
}

export function getAllStickyNotes(id) {
  var url = `${
    APP_SETTINGS.API_PATH.STICKY_NOTES.getAllStickyNotes
  }?page=${1}&limit=${10}&userId=${id}`;
  var response = axios.get(url);
  return response;
}

export function deleteStickyNote(id) {
  var response = axios.delete(
    `${APP_SETTINGS.API_PATH.STICKY_NOTES.deleteStickyNote}?id=${id}`
  );
  return response;
}
